module.exports = __webpack_public_path__ + "static/img/tipos de eval.78981894.jpg";